import { useQuery } from '@tanstack/react-query';

import { getCompanyKpis } from '@arrived/api_v2';
import { CompanyKpis } from '@arrived/models';

import { MAX_STALE_TIME, UseQueryOptions } from '../queries.utils';
import { kpisKey } from './kpis.keys';

export function useGetKpisQuery(options?: UseQueryOptions<CompanyKpis>) {
  return useQuery(kpisKey, () => getCompanyKpis(), { ...options, staleTime: options?.staleTime ?? MAX_STALE_TIME });
}
